<!-- Hero Section -->
<section class="relative overflow-hidden pt-16 pb-24 md:pt-24 md:pb-40">
  <div class="max-w-7xl mx-auto px-6 relative z-10">
    <div class="max-w-3xl">
      <span class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-container text-on-secondary-container text-xs font-bold uppercase tracking-wider mb-6">
        <span class="material-symbols-outlined text-[14px]">auto_awesome</span>
        Next-Gen ERP
      </span>
      <h1 class="text-5xl md:text-7xl font-extrabold tracking-tighter text-on-background mb-8 leading-[1.1]">
        Architecting the Future of Enterprise.
      </h1>
      <p class="text-lg md:text-xl text-on-surface-variant leading-relaxed mb-10 font-body">
        ZAD ERP is a high-performance architectural workspace designed for modern businesses. Streamline operations with precision-engineered modules.
      </p>
      <div class="flex flex-col sm:flex-row gap-4">
        <a routerLink="/create-account" class="bg-gradient-to-r from-primary to-primary-container text-white px-10 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-primary/20 transition-all active:scale-95">Get Started</a>
        <button (click)="openVideo()" class="bg-surface-container-high text-on-primary-fixed-variant px-10 py-4 rounded-xl font-bold text-lg hover:bg-surface-container-highest transition-all active:scale-95">
          Watch Demo
        </button>
      </div>
    </div>
  </div>
  <!-- Abstract Architectural Decor -->
  <div class="absolute top-0 right-0 w-1/2 h-full hidden lg:block">
    <div class="relative w-full h-full p-12">
      <div class="w-full h-full rounded-[2rem] bg-surface-container-low relative overflow-hidden shadow-2xl">
        <img class="w-full h-full object-cover mix-blend-multiply opacity-40" alt="Modern clean software dashboard interface" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB84Yji_YLrfgqqe4xhhr4XDdpcTosx60X5w5kUzDmDny2BjLZOaccasCRy7VumJbc-VE92GNbxsxxx31tmmch7akS6ABYPHS30jyfC2VuF6gslAUpdnEHIJiL3_-yEhpYlZlSi9OCik_GPlmqvxLcZZ1-Z-3p1PLn0LQi9LQDNa2eCdZ6CQjt51GwOkvYAH3_rW0lvMsXFAicoWZ-3NtzkYWST_7KYr5m4J-8aRHGnCM-VrJQQebq3njSOmKPJwwrGY15KbIy6Bj8f" />
        <div class="absolute inset-0 bg-gradient-to-br from-transparent via-surface/50 to-surface"></div>
        <!-- Floating Glass Card -->
        <div class="absolute top-1/4 right-1/4 w-64 h-48 bg-white/80 backdrop-blur-xl rounded-2xl shadow-xl p-6 border border-white/40">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 rounded-lg bg-primary-container/10 flex items-center justify-center">
              <span class="material-symbols-outlined text-primary-container">account_balance_wallet</span>
            </div>
            <div>
              <p class="text-xs font-bold text-on-surface-variant uppercase tracking-widest">Revenue</p>
              <p class="text-xl font-extrabold text-on-surface">+$124.5k</p>
            </div>
          </div>
          <div class="h-2 w-full bg-surface-container rounded-full overflow-hidden">
            <div class="h-full w-2/3 bg-primary"></div>
          </div>
          <p class="text-[10px] text-on-surface-variant mt-4 leading-tight">Projected growth based on Q3 CRM conversion data.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Trust Section -->
<section class="py-16 bg-surface-container-low border-y border-outline-variant/15">
  <div class="max-w-7xl mx-auto px-6">
    <p class="text-center text-sm font-bold text-on-surface-variant uppercase tracking-[0.2em] mb-12">Trusted by Global Leaders</p>
    <div class="flex flex-wrap justify-center items-center gap-12 md:gap-24 opacity-60 grayscale hover:grayscale-0 transition-all duration-700">
      <div class="h-10 w-28 rounded-lg overflow-hidden flex items-center justify-center">
        <img class="h-full w-full object-contain" alt="Aseel Car Rental" src="assets/logo-aseel.png" />
      </div>
      <div class="h-10 w-28 rounded-lg overflow-hidden flex items-center justify-center">
        <img class="h-full w-full object-contain" alt="Falcon Renting for Cars" src="assets/logo-falcon.png" />
      </div>
      <img class="h-8 w-auto" alt="Logistics corporation logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDtFmj4c7X5VqQeZIeeWodN3UWVpj4UlQMcz7jlQwKAlXsX5kpCHhh8tdbcKzYEHgo1JmkUcarPP49RvMC_HLWUv5aUeVUOq9eo8EHUxRprMJIbFZ8fb1ngrkL5-mKIRdFBXsHyfmhMsMLTdFmJhTEb4r2urcAgT_3Y-tMbMDwbqN48F8dMpllpSqFqvxe3xABtfQ5Lkntwmwt0vaJgUhYgd7AYOe80wEZturAfU_GmHw0JSgcwZ7Su-dn2PInollRMwlqjiOYIh2LH" />
      <img class="h-8 w-auto" alt="Tech startup logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDWC79nEX8g0XatlaCx7QRSRdjfwjkoq69CivQgJmexZmWiAymDfKuZd1IEnT9dr6mT_5wM1fQKlkDGEj6zGP_gsZtTZDxoZNp2iyOOjt3QD6R7qInaEVyujHfWo0uzxgZW9gBaVGWeLRIn_RX1pYiH-4dljNtjTtIw853ggTI5uerpJsDNeso0NVBBUQ3akOZ-o8SgGwRzyD1L9zxK98S9cXXC7QI0rlWAGLzfzsh-l74Ltab0Dkj2aNXeXx4Nf6GIBUwiBhTNX7dH" />
      <img class="h-8 w-auto" alt="Financial services logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB6tvnVevia1oqNHwawN7CbH6BInHf-Przw5__vcuERssHOzcQacKzprDJFyCoPVf412MEX_PlNluiT3fYPnjn_6g50MHPcbd5TMjMIWytSRmDhJltbFngp2obV5NKlz5gugBuYiqwEDrvYCTAkxvxo1F_nvxESUegeJ73XCaDr3-bOOIGH8UEk6TYZgWcZO3HDSL-nHCQWohcSL5sUgE1Srhx_EV14ZTN0aA6uYICaeEPiHX0bSehpkcFRIj2uuSKm25rJyJMvawPX" />
    </div>
  </div>
</section>

<!-- Features Section -->
<section class="py-24 bg-surface">
  <div class="max-w-7xl mx-auto px-6">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-12">
      <div class="flex flex-col items-start gap-4">
        <div class="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <span class="material-symbols-outlined text-primary text-2xl">sync</span>
        </div>
        <h3 class="text-xl font-bold text-on-background">Operational Efficiency</h3>
        <p class="text-on-surface-variant leading-relaxed">Automate complex business logic with intelligent workflows that adapt to your architectural requirements.</p>
      </div>
      <div class="flex flex-col items-start gap-4">
        <div class="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <span class="material-symbols-outlined text-primary text-2xl">show_chart</span>
        </div>
        <h3 class="text-xl font-bold text-on-background">Fiscal Clarity</h3>
        <p class="text-on-surface-variant leading-relaxed">Gain total visibility into your financial health with real-time bookkeeping and compliance auditing tools.</p>
      </div>
      <div class="flex flex-col items-start gap-4">
        <div class="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <span class="material-symbols-outlined text-primary text-2xl">schema</span>
        </div>
        <h3 class="text-xl font-bold text-on-background">Scalable Architecture</h3>
        <p class="text-on-surface-variant leading-relaxed">Built on a modular foundation, ZAD ERP grows with your enterprise, supporting multi-branch global operations.</p>
      </div>
    </div>
  </div>
</section>

<!-- Industries Preview Section -->
<section class="py-24 bg-surface-container-low">
  <div class="max-w-7xl mx-auto px-6">
    <div class="text-center mb-16">
      <h2 class="text-3xl md:text-5xl font-black tracking-tight text-on-background mb-4">Vertical Excellence</h2>
      <p class="text-on-surface-variant max-w-2xl mx-auto text-lg">Tailored ERP solutions designed for the specific complexities of your industry.</p>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <!-- Rental -->
      <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10 hover:border-primary/30 transition-all group">
        <div class="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <span class="material-symbols-outlined text-primary text-3xl">car_rental</span>
        </div>
        <a routerLink="/rental" class="block"><h3 class="text-xl font-bold text-on-background mb-3">Vehicle Rental</h3></a>
        <p class="text-on-surface-variant text-sm leading-relaxed">Comprehensive fleet management and automated rental workflows.</p>
      </div>
      <!-- Manufacturing -->
      <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10 hover:border-primary/30 transition-all group">
        <div class="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <span class="material-symbols-outlined text-primary text-3xl">factory</span>
        </div>
        <h3 class="text-xl font-bold text-on-background mb-3">Manufacturing</h3>
        <p class="text-on-surface-variant text-sm leading-relaxed">Real-time supply chain visibility and automated stock replenishment.</p>
      </div>
      <!-- Retail -->
      <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10 hover:border-primary/30 transition-all group">
        <div class="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <span class="material-symbols-outlined text-primary text-3xl">shopping_bag</span>
        </div>
        <h3 class="text-xl font-bold text-on-background mb-3">Retail</h3>
        <p class="text-on-surface-variant text-sm leading-relaxed">Cultivate client relationships with intelligent pipeline management tools.</p>
      </div>
      <!-- Real Estate -->
      <div class="bg-surface-container-lowest p-8 rounded-[2rem] border border-outline-variant/10 hover:border-primary/30 transition-all group">
        <div class="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <span class="material-symbols-outlined text-primary text-3xl">domain</span>
        </div>
        <h3 class="text-xl font-bold text-on-background mb-3">Real Estate</h3>
        <p class="text-on-surface-variant text-sm leading-relaxed">Architect your workflow with advanced Gantt and Agile methodology.</p>
      </div>
    </div>
  </div>
</section>

<!-- Core Modules Section (Bento Grid) -->
<section class="py-24 md:py-32 max-w-7xl mx-auto px-6">
  <div class="text-center mb-20">
    <h2 class="text-3xl md:text-5xl font-black tracking-tight text-on-background mb-4">The Architectural Core</h2>
    <p class="text-on-surface-variant max-w-2xl mx-auto text-lg">Every module is built on a unified data structure for seamless interoperability.</p>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[280px]">
    <!-- Accounting (Large) -->
    <a routerLink="/finance" class="md:col-span-2 row-span-1 bg-surface-container-lowest rounded-[2rem] p-8 flex flex-col justify-between group hover:bg-surface-container transition-all">
      <div class="flex justify-between items-start">
        <div class="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center">
          <span class="material-symbols-outlined text-primary text-3xl">payments</span>
        </div>
        <span class="material-symbols-outlined text-outline-variant group-hover:text-primary transition-colors">arrow_outward</span>
      </div>
      <div>
        <h3 class="text-2xl font-bold mb-2">Accounting</h3>
        <p class="text-on-surface-variant max-w-md">Streamline ledger entries, fiscal reporting, and automated reconciliation.</p>
      </div>
    </a>
    <!-- Sales -->
    <div class="bg-surface-container-low rounded-[2rem] p-8 flex flex-col justify-between hover:bg-surface-container transition-all">
      <div class="w-14 h-14 rounded-2xl bg-secondary/10 flex items-center justify-center">
        <span class="material-symbols-outlined text-secondary text-3xl">trending_up</span>
      </div>
      <div>
        <h3 class="text-xl font-bold mb-2">CRM</h3>
        <p class="text-on-surface-variant text-sm">Cultivate client relationships with intelligent pipeline management tools.</p>
      </div>
    </div>
    <!-- Inventory -->
    <div class="bg-surface-container-low rounded-[2rem] p-8 flex flex-col justify-between hover:bg-surface-container transition-all">
      <div class="w-14 h-14 rounded-2xl bg-tertiary/10 flex items-center justify-center">
        <span class="material-symbols-outlined text-tertiary text-3xl">inventory_2</span>
      </div>
      <div>
        <h3 class="text-xl font-bold mb-2">Inventory Management</h3>
        <p class="text-on-surface-variant text-sm">Real-time supply chain visibility and automated stock replenishment.</p>
      </div>
    </div>
    <!-- HR (Large) -->
    <div class="md:col-span-2 bg-gradient-to-br from-primary-container to-primary rounded-[2rem] p-8 flex flex-col md:flex-row justify-between items-center text-white">
      <div class="max-w-xs mb-6 md:mb-0">
        <div class="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center mb-6">
          <span class="material-symbols-outlined text-white text-3xl">groups</span>
        </div>
        <h3 class="text-2xl font-bold mb-2">Human Resources</h3>
        <p class="text-white/80">Optimize talent acquisition and employee lifecycle orchestration.</p>
      </div>
      <!-- HR Dashboard Mockup -->
      <div class="w-full md:w-1/2 rounded-2xl bg-white/10 backdrop-blur-sm p-4 space-y-3 border border-white/20">
        <!-- Top stats row -->
        <div class="flex gap-2">
          <div class="flex-1 bg-white/15 rounded-xl p-3 text-center">
            <div class="text-2xl font-black text-white leading-none">248</div>
            <div class="text-white/60 text-xs mt-0.5">Employees</div>
          </div>
          <div class="flex-1 bg-white/15 rounded-xl p-3 text-center">
            <div class="text-2xl font-black text-white leading-none">12</div>
            <div class="text-white/60 text-xs mt-0.5">Open Roles</div>
          </div>
          <div class="flex-1 bg-white/15 rounded-xl p-3 text-center">
            <div class="text-2xl font-black text-white leading-none">97%</div>
            <div class="text-white/60 text-xs mt-0.5">Retention</div>
          </div>
        </div>
        <!-- Employee list -->
        <div class="space-y-2">
          <div class="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
            <div class="w-7 h-7 rounded-full bg-yellow-300/80 flex items-center justify-center text-xs font-bold text-yellow-900">SA</div>
            <div class="flex-1 min-w-0">
              <div class="text-white text-xs font-semibold truncate">Sara Al-Amin</div>
              <div class="text-white/50 text-[10px]">HR Manager</div>
            </div>
            <span class="text-[10px] bg-green-400/20 text-green-300 rounded-full px-2 py-0.5">Active</span>
          </div>
          <div class="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
            <div class="w-7 h-7 rounded-full bg-sky-300/80 flex items-center justify-center text-xs font-bold text-sky-900">KM</div>
            <div class="flex-1 min-w-0">
              <div class="text-white text-xs font-semibold truncate">Khalid Mansour</div>
              <div class="text-white/50 text-[10px]">Payroll Specialist</div>
            </div>
            <span class="text-[10px] bg-green-400/20 text-green-300 rounded-full px-2 py-0.5">Active</span>
          </div>
          <div class="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
            <div class="w-7 h-7 rounded-full bg-rose-300/80 flex items-center justify-center text-xs font-bold text-rose-900">LN</div>
            <div class="flex-1 min-w-0">
              <div class="text-white text-xs font-semibold truncate">Layla Nasser</div>
              <div class="text-white/50 text-[10px]">Talent Acquisition</div>
            </div>
            <span class="text-[10px] bg-amber-400/20 text-amber-300 rounded-full px-2 py-0.5">On Leave</span>
          </div>
        </div>
        <!-- Attendance bar -->
        <div class="bg-white/10 rounded-xl px-3 py-2">
          <div class="flex justify-between text-white/60 text-[10px] mb-1.5">
            <span>Today's Attendance</span>
            <span class="text-white font-semibold">94%</span>
          </div>
          <div class="h-1.5 bg-white/20 rounded-full overflow-hidden">
            <div class="h-full bg-green-400 rounded-full" style="width:94%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="py-24 bg-on-background text-white overflow-hidden relative">
  <div class="max-w-7xl mx-auto px-6 text-center relative z-10">
    <h2 class="text-4xl md:text-6xl font-black tracking-tight mb-8">Ready to architect your success?</h2>
    <p class="text-lg text-slate-400 mb-12 max-w-2xl mx-auto">Join thousands of businesses that have transformed their operations with ZAD ERP.</p>
    <div class="flex flex-col sm:flex-row justify-center gap-4">
      <a routerLink="/create-account" class="bg-primary text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-primary-container transition-all">Get Started</a>
      <a routerLink="/contact" class="border border-outline-variant/30 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-white/5 transition-all">Contact Us</a>
    </div>
  </div>
  <!-- Background Graphic -->
  <div class="absolute -bottom-24 -right-24 w-96 h-96 bg-primary/20 rounded-full blur-[120px]"></div>
  <div class="absolute -top-24 -left-24 w-96 h-96 bg-secondary/10 rounded-full blur-[120px]"></div>
</section>

<!-- Video Popup Modal -->
<div *ngIf="showVideoModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6" role="dialog" aria-modal="true">
  <!-- Backdrop with blur -->
  <div (click)="closeVideo()" class="absolute inset-0 bg-black/80 backdrop-blur-md transition-opacity duration-300"></div>

  <!-- Video Container -->
  <div class="relative w-full max-w-4xl bg-surface-container-lowest rounded-[2rem] overflow-hidden shadow-2xl border border-outline-variant/30 transform transition-all duration-300 scale-100 flex flex-col z-10">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-outline-variant/20 bg-surface-container-low">
      <div class="flex items-center gap-2">
        <span class="material-symbols-outlined text-primary">smart_display</span>
        <h3 class="font-bold text-lg text-on-surface">ZAD ERP Platform Demo</h3>
      </div>
      <button (click)="closeVideo()" class="w-8 h-8 rounded-full flex items-center justify-center bg-surface-container hover:bg-surface-container-high text-on-surface-variant hover:text-on-surface transition-colors active:scale-95" aria-label="Close video player">
        <span class="material-symbols-outlined text-xl">close</span>
      </button>
    </div>

    <!-- Aspect Ratio Video Player wrapper -->
    <div class="aspect-video w-full bg-[#f8fafc] relative overflow-hidden flex flex-col justify-between group">
      <style>
        @keyframes modalFadeIn {
          from { opacity: 0; transform: scale(0.98); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-slide-in {
          animation: modalFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      </style>
      
      <!-- SLIDE 0: Intro (0s - 4s) -->
      <div *ngIf="currentSlide === 0" class="absolute inset-0 flex flex-col items-center justify-center text-center p-8 bg-gradient-to-br from-[#f8fafc] to-[#edf2f7] animate-slide-in">
        <div class="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(2,107,255,0.05)_0%,transparent_100%)]"></div>
        <div class="w-20 h-20 rounded-[2rem] bg-primary/10 border-2 border-primary/20 flex items-center justify-center mb-6 animate-pulse">
          <span class="material-symbols-outlined text-primary text-4xl">hub</span>
        </div>
        <h2 class="text-4xl font-extrabold tracking-tighter text-slate-900 mb-3 font-headline">ZAD ERP</h2>
        <p class="text-lg text-primary font-bold uppercase tracking-[0.2em] mb-4">Platform Overview</p>
        <p class="text-slate-500 max-w-md text-sm leading-relaxed">Architecting the Future of Enterprise with unified module ecosystems.</p>
      </div>
 
      <!-- SLIDE 1: Accounting (4s - 8s) -->
      <div *ngIf="currentSlide === 1" class="absolute inset-0 flex flex-col md:flex-row items-center justify-between p-12 bg-gradient-to-br from-[#f8fafc] to-[#edf2f7] gap-8 animate-slide-in">
        <div class="flex-1 space-y-4">
          <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider">
            <span class="material-symbols-outlined text-xs">payments</span> Accounting
          </div>
          <h3 class="text-3xl font-bold text-slate-900 leading-tight">Precision Financial Control</h3>
          <p class="text-slate-600 text-sm leading-relaxed font-body">Automate ledger entries, tax compliance, and multi-company operations with a single ledger view.</p>
        </div>
        <div class="flex-1 w-full max-w-sm bg-white/90 backdrop-blur-md rounded-2xl p-6 border border-slate-200/80 shadow-xl space-y-4">
          <div class="flex justify-between items-center border-b border-slate-100 pb-3">
            <span class="text-xs text-slate-500 font-semibold">Live Revenue</span>
            <span class="text-xs text-green-600 bg-green-100 px-2 py-0.5 rounded-full font-bold">+14.2%</span>
          </div>
          <div class="space-y-1">
            <div class="text-2xl font-black text-slate-900">$142,500.00</div>
            <div class="text-[10px] text-slate-500">Gross Margin: 84%</div>
          </div>
          <div class="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div class="h-full bg-primary rounded-full" style="width: 84%"></div>
          </div>
        </div>
      </div>
 
      <!-- SLIDE 2: Unified Platform (8s - 12s) -->
      <div *ngIf="currentSlide === 2" class="absolute inset-0 flex flex-col md:flex-row items-center justify-between p-12 bg-gradient-to-br from-[#f8fafc] to-[#edf2f7] gap-8 animate-slide-in">
        <div class="flex-1 space-y-4">
          <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider">
            <span class="material-symbols-outlined text-xs">hub</span> One Data Core
          </div>
          <h3 class="text-3xl font-bold text-slate-900 leading-tight">No Data Silos. One Unified Layer.</h3>
          <p class="text-slate-600 text-sm leading-relaxed font-body">Every module—Accounting, CRM, HR, Inventory, and Rental—interoperates in real-time, sharing a single source of truth.</p>
        </div>
        <div class="flex-1 w-full max-w-sm flex items-center justify-center relative min-h-[180px]">
          <div class="w-16 h-16 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary z-10 animate-pulse">
            <span class="material-symbols-outlined text-2xl">database</span>
          </div>
          <div class="absolute w-28 h-28 border border-dashed border-slate-200 rounded-full"></div>
          <!-- Orbiting modules representation -->
          <div class="absolute -top-4 bg-white border border-slate-200/80 rounded-xl px-2.5 py-1 text-[10px] font-bold text-slate-800 flex items-center gap-1.5 shadow-sm">
            <span class="material-symbols-outlined text-xs text-primary">payments</span> Finance
          </div>
          <div class="absolute -bottom-4 bg-white border border-slate-200/80 rounded-xl px-2.5 py-1 text-[10px] font-bold text-slate-800 flex items-center gap-1.5 shadow-sm">
            <span class="material-symbols-outlined text-xs text-secondary">people</span> CRM
          </div>
          <div class="absolute -left-8 bg-white border border-slate-200/80 rounded-xl px-2.5 py-1 text-[10px] font-bold text-slate-800 flex items-center gap-1.5 shadow-sm">
            <span class="material-symbols-outlined text-xs text-tertiary">inventory_2</span> Stock
          </div>
          <div class="absolute -right-8 bg-white border border-slate-200/80 rounded-xl px-2.5 py-1 text-[10px] font-bold text-slate-800 flex items-center gap-1.5 shadow-sm">
            <span class="material-symbols-outlined text-xs text-primary">car_rental</span> Fleet
          </div>
        </div>
      </div>
 
      <!-- SLIDE 3: Fleet & Logistics (12s - 16s) -->
      <div *ngIf="currentSlide === 3" class="absolute inset-0 flex flex-col md:flex-row items-center justify-between p-12 bg-gradient-to-br from-[#f8fafc] to-[#edf2f7] gap-8 animate-slide-in">
        <div class="flex-1 space-y-4">
          <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider">
            <span class="material-symbols-outlined text-xs">local_shipping</span> TransArchitect
          </div>
          <h3 class="text-3xl font-bold text-slate-900 leading-tight">Fleet Lifecycle Automation</h3>
          <p class="text-slate-600 text-sm leading-relaxed font-body">Manage vehicle availability, paperless contract generation, e-signatures, utilization, and preventative maintenance schedules.</p>
        </div>
        <div class="flex-1 w-full max-w-sm bg-white/90 backdrop-blur-md rounded-2xl p-6 border border-slate-200/80 shadow-xl space-y-4">
          <div class="flex justify-between items-center">
            <span class="text-xs text-slate-500 font-bold uppercase tracking-wider">Fleet Utilization</span>
            <span class="text-xs font-bold text-emerald-600">92% Optimal</span>
          </div>
          <div class="flex items-end gap-3 h-16 pt-2">
            <div class="flex-1 bg-primary/15 rounded-t h-8"></div>
            <div class="flex-1 bg-primary/25 rounded-t h-12"></div>
            <div class="flex-1 bg-primary/40 rounded-t h-10"></div>
            <div class="flex-1 bg-primary/50 rounded-t h-14"></div>
            <div class="flex-1 bg-[#026BFF] rounded-t h-16"></div>
          </div>
          <p class="text-[10px] text-slate-450 text-center font-medium">Weekly vehicle occupancy analytics</p>
        </div>
      </div>
 
      <!-- SLIDE 4: Call to Action (16s - 20s) -->
      <div *ngIf="currentSlide === 4" class="absolute inset-0 flex flex-col items-center justify-center text-center p-8 bg-gradient-to-br from-[#f8fafc] to-[#edf2f7] animate-slide-in">
        <div class="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(2,107,255,0.05)_0%,transparent_100%)]"></div>
        <h2 class="text-4xl font-extrabold tracking-tighter text-slate-900 mb-4 font-headline">Start architecting your growth.</h2>
        <p class="text-slate-600 max-w-md text-sm leading-relaxed mb-8">Join thousands of leading companies scaling their business operations with ZAD ERP.</p>
        <div class="flex gap-4">
          <a routerLink="/create-account" (click)="closeVideo()" class="bg-primary hover:bg-primary-container text-white px-8 py-3.5 rounded-xl font-bold transition-all shadow-lg shadow-primary/20 active:scale-95 text-sm">Start Free Trial</a>
          <button (click)="restartVideo()" class="bg-slate-100 hover:bg-slate-200 text-slate-800 border border-slate-200 px-8 py-3.5 rounded-xl font-bold transition-all text-sm flex items-center gap-2 active:scale-95">
            <span class="material-symbols-outlined text-sm">replay</span> Replay
          </button>
        </div>
      </div>
 
      <!-- Video Controls Bar -->
      <div class="absolute bottom-0 inset-x-0 bg-white/90 backdrop-blur-md px-6 py-4 flex flex-col gap-3 border-t border-slate-200/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-30">
        <!-- Progress Bar slider representation -->
        <div class="relative w-full h-1.5 bg-slate-200 rounded-full overflow-hidden cursor-pointer" (click)="restartVideo()">
          <div class="h-full bg-primary rounded-full transition-all duration-1000" [style.width.%]="playerProgress"></div>
        </div>
        
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-4 text-slate-800">
            <button (click)="togglePlay()" class="text-slate-700 hover:text-primary transition-colors flex items-center justify-center" [attr.aria-label]="isPlaying ? 'Pause' : 'Play'">
              <span class="material-symbols-outlined text-2xl">{{isPlaying ? 'pause' : 'play_arrow'}}</span>
            </button>
            <button (click)="restartVideo()" class="text-slate-700 hover:text-primary transition-colors flex items-center justify-center" aria-label="Restart">
              <span class="material-symbols-outlined text-xl">replay</span>
            </button>
            <span class="text-xs text-slate-600 font-mono">0:{{currentTime < 10 ? '0' : ''}}{{currentTime}} / 0:{{totalDuration}}</span>
          </div>
          
          <div class="flex items-center gap-3">
            <span class="text-[10px] font-bold text-primary bg-primary/10 border border-primary/20 px-2 py-0.5 rounded-full uppercase tracking-wider">Live Tour</span>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>

